<div class="card dialog-box">
  <!-- Input for live photos from users -->
  <input
    id="imageFileInputLive"
    class="d-none"
    type="file"
    accept="image/*"
    capture="environment"
    (change)="handleFileInput($event.target)"
  />

  <!-- Input for photos uploaded from device -->

  <input
    id="imageFileInput"
    class="d-none"
    type="file"
    accept=".jpg, .jpeg, .png, .webp, .avif"
    (change)="handleFileInput($event.target)"
  />

  <input
    id="imageVideoFileInput"
    class="d-none"
    type="file"
    accept=".jpg, .jpeg, .png, .webp, .avif, .mp4, .mov, .webm, .mkv"
    (change)="handleFileInput($event.target)"
  />
  <input
    id="videoFileInputLive"
    class="d-none"
    type="file"
    accept="video/*"
    capture="environment"
    (change)="handleFileInput($event.target)"
  />

  <!-- Input for photos uploaded from device -->
  <input
    id="videoFileInput"
    class="d-none"
    type="file"
    accept=".mp4, .mov, .webm,.mkv"
    (change)="handleFileInput($event.target)"
  />
  @if (fileErrorMessage?.message) {
    <div class="alert alert-danger text-center my-3">
      {{ fileErrorMessage?.message }}
    </div>
  }
  @if (fileErrorMessage?.videoMetaData) {
    <div class="border border-info rounded shadow p-2 mb-3">
      <div class="row row-cols-3">
        <div></div>
        <div class="fw-semibold">Current</div>
        <div class="fw-semibold">Preferred</div>
        <div>Size (MB)</div>
        <div class="fw-semibold">
          {{ fileErrorMessage?.videoMetaData?.sizeInMb }}
        </div>
        <div class="fw-semibold">< 50</div>
        @if (
          fileErrorMessage?.videoMetaData?.videoWidth &&
          fileErrorMessage?.videoMetaData?.videoHeight
        ) {
          <div>Resolution</div>
          <div class="fw-semibold">
            {{ fileErrorMessage?.videoMetaData?.videoWidth }} X
            {{ fileErrorMessage?.videoMetaData?.videoHeight }}
          </div>
          <div class="fw-semibold">720 X 480</div>
        }
      </div>
    </div>
  }
  @if (isCameraOpen && !actualUploadFile && !fileUrl) {
    <div class="row row-cols-2">
      <div class="col">
        <button class="btn btn-dark btn-lg w-100" (click)="close()">
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="selectDeviceUploadType(); fileUrl = null"
        >
          Retry
        </button>
      </div>
    </div>
  }

  <!-- Image display section -->
  @if (fileUrl && showFrom !== "updateClient") {
    <div class="mb-2">
      <gtapp-media-preview
        [mediaSrc]="fileUrl"
        [mediaExtension]="fileExtension"
      >
      </gtapp-media-preview>
    </div>
    @if (!["userProfilePage", "mobileForm"].includes(showFrom)) {
      <div class="form-group mb-2">
        <textarea
          rows="1"
          class="form-control"
          maxlength="300"
          placeholder="Comment (Optional)"
          [(ngModel)]="newComment"
        ></textarea>
      </div>
    }
    <div class="row row-cols-2">
      <div class="col">
        <button class="btn btn-dark btn-lg w-100" (click)="close()">
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          (click)="onFileSubmit()"
          [disabled]="!fileUrl || !actualUploadFile"
          class="btn btn-primary btn-lg w-100"
        >
          {{ btnLable }}
        </button>
      </div>
    </div>
  }

  <!-- Section for blocking app interaction during client update -->
  @if (fileUrl && showFrom == "updateClient") {
    <!-- No sites found message -->
    @if (!apidataUpdation && clientCount === 0) {
      <div class="empty-add-photo">
        <div class="alert alert-warning">No sites found</div>
        <div class="col">
          <button class="btn btn-dark btn-lg w-100" (click)="close()">
            Back
          </button>
        </div>
      </div>
    }
    @if (apidataUpdation || (!apidataUpdation && clientCount > 0)) {
      <div>
        <div class="image-max-height mb-2">
          <gtapp-media-preview
            [mediaSrc]="fileUrl"
            [mediaExtension]="fileExtension"
          >
          </gtapp-media-preview>
        </div>
        <div class="form-group my-3">
          <textarea
            class="form-control"
            rows="1"
            maxlength="300"
            placeholder="Comment (Optional)"
            [disabled]="!apidataUpdation && clientCount === 0 ? true : false"
            [(ngModel)]="newComment"
          ></textarea>
        </div>
        @if (groupUserCount > 1) {
          <div class="mb-4">
            <label for="handLog">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="handOverLogDraft"
                (change)="handOverLogDraft = !handOverLogDraft"
                id="handLog"
              />
              Include in handover log</label
            >
          </div>
        }
        <div class="row row-cols-2">
          <div class="col">
            <button class="btn btn-dark btn-lg w-100" (click)="close()">
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              (click)="onSavePhoto()"
              class="btn btn-primary btn-lg w-100"
              [disabled]="!fileUrl || !actualUploadFile"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    }
  }
</div>
